import { missionDetailText } from './missionDetailTexts';

/** Twin of DRESS_CODE_MAX_LENGTH in api updateMissionDetails.usecase.js. */
export const DRESS_CODE_MAX_LENGTH = 500;

const trimmed = (value) => (typeof value === 'string' ? value.trim() : '');

/** The contact as the form edits it: two strings, never undefined. */
export const contactFormOf = (mission) => ({
  name: mission?.contact?.name || '',
  poste: mission?.contact?.poste || '',
});

/** The `dressCode` change of the edit form, or null; empty removes it. */
export const dressCodeChange = (mission, value) => {
  const before = trimmed(mission?.dressCode);
  const after = trimmed(value);
  return before === after ? null : { field: 'dressCode', before, after };
};

/** The `contact` change of the edit form, or null. */
export const contactChange = (mission, contact) => {
  const before = contactFormOf(mission);
  const after = {
    name: trimmed(contact?.name),
    poste: trimmed(contact?.poste),
  };
  return before.name.trim() === after.name &&
    before.poste.trim() === after.poste
    ? null
    : { field: 'contact', before, after };
};

/** Why the dress code cannot be saved, or null. Checked as the api checks it. */
export const dressCodeError = (value) =>
  trimmed(value).length > DRESS_CODE_MAX_LENGTH
    ? missionDetailText('requirements.dressCodeTooLong')
    : null;

/**
 * Why the contact cannot be saved, or null. Only a contact being changed is
 * held to it: a mission created without one stays editable on other fields.
 */
export const contactError = (mission, contact) =>
  contactChange(mission, contact) && trimmed(contact?.name) === ''
    ? missionDetailText('info.contactNameRequired')
    : null;
